import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import findIndex from 'lodash/findIndex'
import Chart from 'chart.js'
import 'chartjs-plugin-datalabels'

class GenderChart extends React.PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'data')) !== JSON.stringify(prevState.data)) {
      const data = get(nextProps, 'data')
      const male = []
      const female = []
      const total = []
      Object.keys(get(data, ['0'], [])).forEach(key => {
        if (key !== 'gender') {
          male.push({ label: key, value: data[0][key] })
        }
      })
      Object.keys(get(data, ['1'], [])).forEach(key => {
        if (key !== 'gender') {
          female.push({ label: key, value: data[1][key] })
        }
      })
      Object.keys(get(data, ['2'], [])).forEach(key => {
        if (key !== 'gender') {
          total.push({ label: key, value: data[2][key] })
        }
      })
      const labels = []
      let totalData = orderBy(total, 'label', 'asc')
      const totalIndex = findIndex(totalData, { label: 'total' })
      if (totalIndex > -1) {
        const tempTotal = totalData[totalIndex]
        totalData.splice(totalIndex, 1)
        totalData.splice(totalData.length, 0, tempTotal)
      }
      totalData = totalData.map(label => {
        labels.push(get(label, 'label'))
        return get(label, 'value')
      })
      const maleData = orderBy(male, 'label', 'asc')
      const totalIndexM = findIndex(maleData, { label: 'total' })
      if (totalIndexM > -1) {
        const tempTotalM = maleData[totalIndexM]
        maleData.splice(totalIndexM, 1)
        maleData.splice(maleData.length, 0, tempTotalM)
      }
      let malePercent = [...maleData]
      malePercent = malePercent.map((label, index) => {
        return totalData[index] !== 0 ? parseFloat((get(label, 'value') / totalData[index]) * 100).toFixed(2) : '0.00'
      })
      const femaleData = orderBy(female, 'label', 'asc')
      const totalIndexF = findIndex(femaleData, { label: 'total' })
      if (totalIndexF > -1) {
        const tempTotalF = femaleData[totalIndexF]
        femaleData.splice(totalIndexF, 1)
        femaleData.splice(femaleData.length, 0, tempTotalF)
      }
      let femalePercent = [...femaleData]
      femalePercent = femalePercent.map((label, index) => {
        return totalData[index] !== 0 ? parseFloat((get(label, 'value') / totalData[index]) * 100).toFixed(2) : '0.00'
      })
      set(tempState, 'maleData', maleData)
      set(tempState, 'malePercent', malePercent)
      set(tempState, 'femaleData', femaleData)
      set(tempState, 'femalePercent', femalePercent)
      set(tempState, 'totalData', totalData)
      set(tempState, 'labels', labels)
      set(tempState, 'data', get(nextProps, 'data'))
    }
    return tempState
  }

  state={ data: [] }

  componentDidMount() {
    this.forceUpdate()
  }

  renderChart = () => {
    const { labels, maleData, malePercent, femaleData, femalePercent } = this.state
    const chart = document.getElementById(get(this.props, 'idchart')).getContext("2d")

    // eslint-disable-next-line no-new
    new Chart(chart, {
      type: 'bar',
      data: {
        labels,
        datasets: [{
          label: "Male",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          type: "bar",
          backgroundColor: "#374C80",
          data: malePercent,
        }, {
          label: "Female",
          id: "y-axis-0",
          yAxisID: 'y-axis-0',
          type: "bar",
          backgroundColor: "#BC5090",
          data: femalePercent,
        },
        ],
      },
      options: {
        layout: {
          padding: {
            top: 15,
          },
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 15,
          },
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
        maintainAspectRatio: false,
        tooltips: {
          display: true,
          mode: 'label',
          callbacks: {
            label: (tooltipItem, data) => {
              const dataIndex = tooltipItem.datasetIndex
              const index = tooltipItem.index
              let rawData
              switch (dataIndex) {
                case 0: {
                  rawData = maleData
                  break
                }
                case 1: {
                  rawData = femaleData
                  break
                }
                default: break
              }
              return `${data.datasets[dataIndex].label}: ${get(rawData, [index, 'value'])} (${data.datasets[dataIndex].data[index]}%)`
            },
          },
        },
        chartArea: {
          backgroundColor: '#EDEFF5',
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false,
            },
          }],
          yAxes: [{
            stacked: true,
            position: "left",
            id: "y-axis-0",
            ticks: {
              min: 0,
              max: 100,
              stepSize: 25,
              callback: (value) => {
                return `${value}%`
              },
            },
          }],
        },
      },
    })
  }

  render() {
    if (document.getElementById(get(this.props, 'idchart')) !== null) {
      this.renderChart()
    }
    return (
      <Wrapper>
        <canvas id={ get(this.props, 'idchart') } width='100%' height={ 300 } />
      </Wrapper>
    )
  }
}

export default GenderChart

const Wrapper = styled.div`
  width: 100%;
  height: 300px;
  background-color: #ffffff;
`




// WEBPACK FOOTER //
// ./src/components/report/charts/headcount/gender-chart.js